(function ($) {
    'use strict';

    /**
     * Expands of collapses the search form in listings
     */
    function ListSearchExpand () {
    }

    ListSearchExpand.prototype = {

      init: function () {
        // Check for a list search form element
        if ($('.js-list-search-btn').length === 0) return;

        const $listSearchForm = $('.js-list-search-form');
        const $listSearchButton = $('.js-list-search-btn');
        const $listSearchCloseBtn = $('.js-search-close-btn');

        // Open search form
        $listSearchButton.on('click', function () {
          $listSearchButton.toggleClass('expanded');
          $listSearchForm.slideToggle();
        });

        // Toggle aria-expanded
        $listSearchButton.on('click', function () {
          $listSearchForm.attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
          });
        });

        // On close button click
        $listSearchCloseBtn.on('click', function (e) {
          // Ignore the 'required' on the input
          e.preventDefault();

          $listSearchForm.css('display', 'none');
          $listSearchButton.removeClass('expanded');
          $listSearchForm.attr('aria-expanded', 'false');
        })
      }
    };

    this.ListSearchExpand = ListSearchExpand;
  }).call(Framework, jQuery);
